import type { BFFArticleBodyElement } from "@src/app/types/bff";

import OptimisedImage from "../../OptimisedImage/OptimisedImage";

export default function ArticleImage({
  element,
}: {
  element: BFFArticleBodyElement["image"];
}) {
  return (
    <figure className="pb-4">
      <OptimisedImage
        filters={{
          lg: { f: "webp", w: 720, q: 80, dpr: 3 },
          md: { f: "webp", w: 720, q: 80, dpr: 3 },
          sm: { f: "webp", w: 360, q: 80, dpr: 3 },
        }}
        rootClassName="w-full"
        src={element.url}
        alt={element.altText || element.caption}
        fetchPriority="high"
      />
      {element.caption ? (
        <figcaption className="mt-3 text-left text-body-2 font-medium text-tertiary">
          {`${element.caption}${element.credit ? `（${element.credit}）` : ""}`}
        </figcaption>
      ) : null}
    </figure>
  );
}
